export enum MODULE_NAME {
  GENERAL = "General",
  DASHBOARD = "Dashboard",
  USERS = "Users",
  PARTICIPANTS_LIST = "Participants list",
  PARTICIPANTS_MANAGE_OFFICERS = "Participant manage officers",
  PARTICIPANTS_MANAGE_SUPPORT_STAFF = "Participant manage support staff",
  PARTICIPANTS_MANAGE_INTERNAL_PROVIDER = "Participant manage internal providers",
  PARTICIPANTS_MANAGE_CASE_PLAN = "Participant manage case plan",
  PARTICIPANT_GOALS = "Participant goals",
  PARTICIPANT_REWARDS = "Participant rewards",
  PARTICIPANT_JOURNALS = "Participant journals",
  SIGN_IN = "Sign in",
  SIGN_OUT = "Sign out",
  CHAT = "Chat",
  SCREENING_COLORS = "Screening colors",
  SETTINGS = "Settings",
  ORGANIZATIONS = "Organizations",
  ORGANIZATION_LABELS = "Organization labels",
  ACTIONS = "Actions",
  ROLES = "Roles",
  EDUCATIONAL_RESOURCES = "Educational resources",
  CATEGORIES = "Categories",
  PROGRAMS = "Programs",
  EXTERNAL_PROVIDERS = "External providers",
  GOAL_TEMPLATES = "Goal templates",
  TERMS = "Terms",
}

export enum OPTIONS {
  AUDIT_LOG_VIEW = "Audit log view",
  EMAIL_MATCHING = "Email matching",
  TERMS_AND_CONDITIONS = "T&C",
  VERIFY_CODE = "Verify code",
  SESSION_START = "Session start",
  SIGN_OUT = "Sign out",
  CHANGE_LANGUAGE = "Change language",
  REQUEST_ACCOUNT_DELETION = "Request account deletion",
  USERS_GUIDE = "User’s guide",
  HOME = "Home",
  DASHBOARD = "Dashboard",
  PARTICIPANTS_LIST = "Participants list",
  PARTICIPANT_ADD = "Participant add",
  PARTICIPANT_PROFILE = "Participant profile",
  PARTICIPANT_EDIT = "Participant edit",
  PARTICIPANT_DISMISS = "Participant dismiss",
  MANAGE_OFFICERS = "Manage officers",
  MANAGE_SUPPORT_STAFF = "Manage support staff",
  MANAGE_INTERNAL_PROVIDERS = "Manage internal providers",
  MANAGE_CASE_PLAN = "Manage case plan",
  PARTICIPANT_GOALS_LIST = "Participant goals list",
  DELETE_GOAL_FROM_PARTICIPANT = "Delete goal from participant",
  DELETE_STEP_FROM_PARTICIPANT = "Delete step from participant",
  WEB_PART_GOAL_ADD = "When added new goal",
  GOAL_FROM_TEMPLATE_TO_PARTICIPANT = "Goal from template to participant",
  EDIT_GOAL_TO_PARTICIPANT = "Edit goal to participant",
  STEP_APPROVAL_TO_PARTICIPANT = "Step approval to participant",
  STEP_REJECTION_TO_PARTICIPANT = "Step rejection to participant",
  PARTICIPANT_JOURNALS_LIST = "Participant journals list",
  PARTICIPANT_JOURNAL = "Participant journal",
  PARTICIPANT_REWARDS_LIST = "Participant rewards list",
  PARTICIPANT_REWARD_REDEMPTION = "Participant reward redemption",
  PARTICIPANT_REWARD_VIEW_DETAIL_FROM_EXTERNAL_PROVIDER = "Participant reward view detail from external provider",
  ADD_INDIVIDUAL_APPOINTMENT = "Add individual appointment",
  EDIT_INDIVIDUAL_APPOINTMENT = "Edit individual appointment",
  ADD_GROUP_APPOINTMENT = "Add group appointment",
  EDIT_GROUP_APPOINTMENT = "Edit group appointment",
  DELETE_APPOINTMENT = "Delete appointment",
  MARK_AS_ABSENT = "Mark as absent",
  REVERT_ABSENCE = "Revert absence",
  LOG_ACTIVITY = "Log activity",
  LOG_WALK_IN_ACTIVITY = "Log walk-in activity",
  IN_HOUSE_SERVICE_ACTIVITY_DETAIL = "In-house service activity detail",
  USERS_LIST = "Users list",
  USER_ADD_EDIT = "User add / edit",
  DELETE = "Delete",
  RESEND_VERIFICATION_LINK = "Resend verification link",
  CHAT_CONTACTS = "Chat contacts",
  CHAT_WINDOW = "Chat window",
  SCREENING_COLORS_VIEW = "Screening colors view",
  SCREENING_COLORS_AUDIT_LOG_VIEW = "Screening colors audit log view",
  SCREENING_COLORS_ADD = "Screening colors add",
  SCREENING_COLORS_EDIT = "Screening colors edit",
  SCREENING_COLORS_DELETE = "Screening colors delete",
  SCREENING_COLORS_BATCH_UPLOAD = "Screening colors batch upload",
  CLOSURE_AND_HOURS = "Closure and Hours",
  CLOSURE_EDIT = "Closure Edit",
  WEEKLY_HOURS = "Weekly Hours",
  ORGANIZATIONS_LIST = "Organizations list",
  ORGANIZATION_ADD_EDIT = "Organization add / edit",
  ORGANIZATION_LABELS_LIST = "Organization labels list",
  ORGANIZATION_LABEL_ADD_EDIT = "Organization label add / edit",
  ACTIONS_LIST = "Actions list",
  ACTION_ADD_EDIT = "Action add / edit",
  ROLES_LIST = "Roles list",
  ROLE_ADD_EDIT = "Role add / edit",
  EDUCATIONAL_RESOURCES_LIST = "Educational resources list",
  EDUCATIONAL_RESOURCE_ADD_EDIT = "Educational resource add / edit",
  CATEGORIES_LIST = "Categories list",
  CATEGORY_ADD_EDIT = "Category add / edit",
  PROGRAMS_LIST = "Programs list",
  PROGRAM_ADD_EDIT = "Program add / edit",
  EXTERNAL_PROVIDERS_LIST = "External providers list",
  EXTERNAL_PROVIDER_ADD_EDIT = "External provider add / edit",
  GOAL_TEMPLATES_LIST = "Goal templates list",
  GOAL_TEMPLATE_ADD_EDIT = "Goal template add / edit",
  TERMS_LIST = "Terms list",
  TERM_ADD_EDIT = "Term add / edit",
  TERM_ACTIVATE = "Term activate",
  SETTINGS_CATALOG_LIST = "Settings catalog list",
  SETTING_ADD_EDIT = "Setting add / edit",
  ACCOUNT_SETTINGS_LIST = "Account settings list",
  ACCOUNT_SETTING_VALUE = "Account setting value",
}

export enum ACTION_CODE {
  MOB_SIGNUP_EMAIL_MATCH = "MOB_SIGNUP_EMAIL_MATCH",
  MOB_SIGNUP_TYC_OK = "MOB_SIGNUP_TYC_OK",
  MOB_SIGNUP_TYC_DECLINED = "MOB_SIGNUP_TYC_DECLINED",
  MOB_SIGNUP_ACCOUNT_COMPLETED = "",
  MOB_SIGNUP_RESEND_CODE = "MOB_SIGNUP_RESEND_CODE",
  MOB_SIGNIN_SUCCESSFULLY = "MOB_SIGNIN_SUCCESSFULLY",
  MOB_SETTING_CHN_LANG_ENTER = "MOB_SETTING_CHN_LANG_ENTER",
  MOB_SETTING_CHN_LANG_SUBMITTED = "MOB_SETTING_CHN_LANG_SUBMITTED",
  MOB_SETTING_DEL_ACCT_ENTER = "MOB_SETTING_DEL_ACCT_ENTER",
  MOB_SETTING_USER_GUIDE_ENTER = "MOB_SETTING_USER_GUIDE_ENTER",
  MOB_HOME_ENTER = "MOB_HOME_ENTER",
  WEB_GEN_LIST_AUDITLOG_VIEW = "WEB_GEN_LIST_AUDITLOG_VIEW",
  WEB_DASHBOARD_VIEW = "WEB_DASHBOARD_VIEW",
  WEB_PART_LIST_VIEW = "WEB_PART_LIST_VIEW",
  WEB_PART_LIST_SEARCH = "WEB_PART_LIST_SEARCH",
  WEB_PART_ADD_INVITE = "WEB_PART_ADD_INVITE",
  WEB_PART_PROFILE_VIEW = "WEB_PART_PROFILE_VIEW",
  WEB_PART_EDIT = "WEB_PART_EDIT",
  WEB_PART_DISMISS = "WEB_PART_DISMISS",
  WEB_PART_ADDED_OFFICERS = "WEB_PART_ADDED_OFFICERS",
  WEB_PART_REMOVED_OFFICERS = "WEB_PART_REMOVED_OFFICERS",
  WEB_PART_ADDED_STAFF = "WEB_PART_ADDED_STAFF",
  WEB_PART_REMOVED_STAFF = "WEB_PART_REMOVED_STAFF",
  WEB_PART_ADDED_INT_PROVIDERS = "WEB_PART_ADDED_INT_PROVIDERS",
  WEB_PART_REMOVED_INT_PROVIDERS = "WEB_PART_REMOVED_INT_PROVIDERS",
  WEB_PART_GOAL_LIST_VIEW = "WEB_PART_GOAL_LIST_VIEW",
  WEB_PART_GOAL_ADDED_TEMPLATE = "WEB_PART_GOAL_ADDED_TEMPLATE",
  WEB_PART_GOAL_ADD = "WEB_PART_GOAL_ADD",
  WEB_PART_GOAL_EDIT = "WEB_PART_GOAL_EDIT",
  WEB_PART_GOAL_DELETE = "WEB_PART_GOAL_DELETE",
  WEB_PART_GOAL_STEP_APPROVE = "WEB_PART_GOAL_STEP_APPROVE",
  WEB_PART_GOAL_STEP_REJECT = "WEB_PART_GOAL_STEP_REJECT",
  WEB_PART_GOAL_STEP_DELETE = "WEB_PART_GOAL_STEP_DELETE",
  WEB_PART_JOURNAL_LIST_VIEW = "WEB_PART_JOURNAL_LIST_VIEW",
  WEB_PART_JOURNAL_VIEW = "WEB_PART_JOURNAL_VIEW",
  WEB_PART_REWARDS_VIEW = "WEB_PART_REWARDS_VIEW",
  WEB_PART_REWARD_REDEMPTION_APPROVE = "WEB_PART_REWARD_REDEMPTION_APPROVE",
  WEB_PART_REWARD_REDEMPTION_EXECUTE = "WEB_PART_REWARD_REDEMPTION_EXECUTE",
  WEB_PART_REWARD_REDEMPTION_REJECT = "WEB_PART_REWARD_REDEMPTION_REJECT",
  WEB_PART_REWARD_EXT_PROV_DETAIL_VIEW = "WEB_PART_REWARD_EXT_PROV_DETAIL_VIEW",
  WEB_APPT_IND_ADD = "WEB_APPT_IND_ADD",
  WEB_APPT_IND_EDIT = "WEB_APPT_IND_EDIT",
  WEB_APPT_GRP_ADD = "WEB_APPT_GRP_ADD",
  WEB_APPT_DELETE = "WEB_APPT_DELETE",
  WEB_APPT_GRP_REMOVED = "WEB_APPT_GRP_REMOVED",
  WEB_APPT_MARK_ABSENT = "WEB_APPT_MARK_ABSENT",
  WEB_APPT_REVERT_ABSENCE = "WEB_APPT_REVERT_ABSENCE",
  WEB_APPT_LOG_ACTIVITY = "WEB_APPT_LOG_ACTIVITY",
  WEB_INHSE_LOG_WALKIN_ACTIVITY = "WEB_INHSE_LOG_WALKIN_ACTIVITY",
  WEB_INHSE_IN_HOUSE_VIEW = "WEB_INHSE_IN_HOUSE_VIEW",
  WEB_USRS_LIST_VIEW = "WEB_USRS_LIST_VIEW",
  WEB_USRS_LIST_SEARCH = "WEB_USRS_LIST_SEARCH",
  WEB_USRS_USR_ADD_INVITE = "WEB_USRS_USR_ADD_INVITE",
  WEB_USRS_USR_VIEW = "WEB_USRS_USR_VIEW",
  WEB_USRS_USR_EDIT = "WEB_USRS_USR_EDIT",
  WEB_USRS_USR_DELETE = "WEB_USRS_USR_DELETE",
  WEB_USRS_USR_RESEND_LINK = "WEB_USRS_USR_RESEND_LINK",
  WEB_SIGN_OUT_OK = "WEB_SIGN_OUT_OK",
  WEB_SIGN_OUT_TIMEOUT = "WEB_SIGN_OUT_TIMEOUT",
  CHAT_CONTACTS_VIEW = "CHAT_CONTACTS_VIEW",
  CHAT_MESSAGES_VIEW = "CHAT_MESSAGES_VIEW",
  WEB_COLORS_LIST_VIEW = "WEB_COLORS_LIST_VIEW",
  WEB_COLORS_AUDIT_LOG_VIEW = "WEB_COLORS_AUDIT_LOG_VIEW",
  WEB_COLORS_ADD = "WEB_COLORS_ADD",
  WEB_COLORS_EDIT = "WEB_COLORS_EDIT",
  WEB_COLORS_DELETE = "WEB_COLORS_DELETE",
  WEB_COLORS_BATCH_UPLOAD = "WEB_COLORS_BATCH_UPLOAD",
  WEB_PART_ENTER_CASE_PLAN = "WEB_PART_ENTER_CASE_PLAN",
  WEB_PART_ADDED_CASE_PLAN = "WEB_PART_ADDED_CASE_PLAN",
  WEB_PART_DELETED_CASE_PLAN = "WEB_PART_DELETED_CASE_PLAN",
  WEB_SETTINGS_CLOSURE_HOURS_ENTER = "WEB_SETTINGS_CLOSURE_HOURS_ENTER",
  WEB_SETTINGS_CLOSURE_ENTER = "WEB_SETTINGS_CLOSURE_ENTER",
  WEB_SETTINGS_CLOSURE_SAVE = "WEB_SETTINGS_CLOSURE_SAVE",
  WEB_SETTINGS_HOURS_SAVE = "WEB_SETTINGS_HOURS_SAVE",
  WEB_ORG_LIST_VIEW = "WEB_ORG_LIST_VIEW",
  WEB_ORG_LIST_SEARCH = "WEB_ORG_LIST_SEARCH",
  WEB_ORG_ADD = "WEB_ORG_ADD",
  WEB_ORG_EDIT = "WEB_ORG_EDIT",
  WEB_ORG_DELETE = "WEB_ORG_DELETE",
  WEB_ORG_LABEL_LIST_VIEW = "WEB_ORG_LABEL_LIST_VIEW",
  WEB_ORG_LABEL_LIST_SEARCH = "WEB_ORG_LABEL_LIST_SEARCH",
  WEB_ORG_LABEL_ADD = "WEB_ORG_LABEL_ADD",
  WEB_ORG_LABEL_EDIT = "WEB_ORG_LABEL_EDIT",
  WEB_ORG_LABEL_DELETE = "WEB_ORG_LABEL_DELETE",
  WEB_ACTION_LIST_VIEW = "WEB_ACTION_LIST_VIEW",
  WEB_ACTION_LIST_SEARCH = "WEB_ACTION_LIST_SEARCH",
  WEB_ACTION_ADD = "WEB_ACTION_ADD",
  WEB_ACTION_EDIT = "WEB_ACTION_EDIT",
  WEB_ACTION_DELETE = "WEB_ACTION_DELETE",
  WEB_ROLE_LIST_VIEW = "WEB_ROLE_LIST_VIEW",
  WEB_ROLE_LIST_SEARCH = "WEB_ROLE_LIST_SEARCH",
  WEB_ROLE_ADD = "WEB_ROLE_ADD",
  WEB_ROLE_EDIT = "WEB_ROLE_EDIT",
  WEB_ROLE_DELETE = "WEB_ROLE_DELETE",
  WEB_EDU_RES_LIST_VIEW = "WEB_EDU_RES_LIST_VIEW",
  WEB_EDU_RES_LIST_SEARCH = "WEB_EDU_RES_LIST_SEARCH",
  WEB_EDU_RES_ADD = "WEB_EDU_RES_ADD",
  WEB_EDU_RES_EDIT = "WEB_EDU_RES_EDIT",
  WEB_EDU_RES_DELETE = "WEB_EDU_RES_DELETE",
  WEB_CAT_LIST_VIEW = "WEB_CAT_LIST_VIEW",
  WEB_CAT_LIST_SEARCH = "WEB_CAT_LIST_SEARCH",
  WEB_CAT_ADD = "WEB_CAT_ADD",
  WEB_CAT_EDIT = "WEB_CAT_EDIT",
  WEB_CAT_DELETE = "WEB_CAT_DELETE",
  WEB_SETTING_CAT_LIST_VIEW = "WEB_SETTING_CAT_LIST_VIEW",
  WEB_SETTING_CAT_LIST_SEARCH = "WEB_SETTING_CAT_LIST_SEARCH",
  WEB_SETTING_CAT_ADD = "WEB_SETTING_CAT_ADD",
  WEB_SETTING_CAT_EDIT = "WEB_SETTING_CAT_EDIT",
  WEB_SETTING_CAT_DELETE = "WEB_SETTING_CAT_DELETE",
  WEB_ACCT_SETTING_LIST_VIEW = "WEB_ACCT_SETTING_LIST_VIEW",
  WEB_ACCT_SETTING_SET = "WEB_ACCT_SETTING_SET",
  WEB_ACCT_SETTING_CLEAR = "WEB_ACCT_SETTING_CLEAR",
  WEB_PROG_LIST_VIEW = "WEB_PROG_LIST_VIEW",
  WEB_PROG_LIST_SEARCH = "WEB_PROG_LIST_SEARCH",
  WEB_PROG_ADD = "WEB_PROG_ADD",
  WEB_PROG_EDIT = "WEB_PROG_EDIT",
  WEB_PROG_DELETE = "WEB_PROG_DELETE",
  WEB_EXT_PROV_LIST_VIEW = "WEB_EXT_PROV_LIST_VIEW",
  WEB_EXT_PROV_LIST_SEARCH = "WEB_EXT_PROV_LIST_SEARCH",
  WEB_EXT_PROV_ADD = "WEB_EXT_PROV_ADD",
  WEB_EXT_PROV_EDIT = "WEB_EXT_PROV_EDIT",
  WEB_EXT_PROV_DELETE = "WEB_EXT_PROV_DELETE",
  WEB_GOAL_TPL_LIST_VIEW = "WEB_GOAL_TPL_LIST_VIEW",
  WEB_GOAL_TPL_LIST_SEARCH = "WEB_GOAL_TPL_LIST_SEARCH",
  WEB_GOAL_TPL_ADD = "WEB_GOAL_TPL_ADD",
  WEB_GOAL_TPL_EDIT = "WEB_GOAL_TPL_EDIT",
  WEB_GOAL_TPL_DELETE = "WEB_GOAL_TPL_DELETE",
  WEB_TERM_LIST_VIEW = "WEB_TERM_LIST_VIEW",
  WEB_TERM_LIST_SEARCH = "WEB_TERM_LIST_SEARCH",
  WEB_TERM_ADD = "WEB_TERM_ADD",
  WEB_TERM_EDIT = "WEB_TERM_EDIT",
  WEB_TERM_DELETE = "WEB_TERM_DELETE",
  WEB_TERM_ACTIVATE = "WEB_TERM_ACTIVATE",
}
